// "Recently viewed" row (sections/bjo-recently-viewed.liquid, empty cart in main-cart-items.liquid): this phone's last 12
// products, newest first, current one left out. Cards are kept in localStorage (bjoCardCache) so the row shows at once,
// then refreshed from /products/<handle>?view=card in the background (Hamza 2026-10-30: "can it be preloaded").
(() => {
const init = (box) => {
  if (!box || box.dataset.ready) return;
  box.dataset.ready = '1';
  const KEY = 'bjoRecent', CACHE = 'bjoCardCache', DAY = 864e5, here = box.dataset.handle;
  const read = (k, d) => { try { return JSON.parse(localStorage.getItem(k) || d); } catch (e) { return JSON.parse(d); } };
  const write = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  const list = read(KEY, '[]');
  const show = list.filter((h) => h !== here).slice(0, 12);
  // no product here (empty cart page): only read the history, never write it
  const kept = here ? [here, ...list.filter((h) => h !== here)].slice(0, 13) : list;
  if (here) write(KEY, kept);
  // title/photo/brand for the search box's "Recently viewed" (assets/predictive-search.js): shown there with no request.
  // Title per language, so Arabic search shows the Arabic title once the product was seen in Arabic. Hamza 2026-10-25
  if (here) try {
    const info = read('bjoRecentInfo', '{}'), out = {};
    const d = box.dataset, cur = info[here] || { t: {} };
    cur.t = Object.assign({}, cur.t, { [d.lang === 'ar' ? 'ar' : 'en']: d.title });
    cur.v = d.vendor; cur.i = d.img; delete cur.gone;
    info[here] = cur;
    kept.forEach((h) => { if (info[h]) out[h] = info[h]; }); // only what is still in the history
    write('bjoRecentInfo', out);
  } catch (e) {}
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const lang = box.dataset.lang === 'ar' ? 'ar' : 'en';
  const cache = read(CACHE, '{}');
  const card = (h) => fetch(root + 'products/' + h + '?view=card').then((r) => (r.ok ? r.text() : '')).catch(() => '')
    .then((html) => { if (html.includes('card-wrapper')) cache[lang + ':' + h] = { h: html, t: Date.now() }; return html; });
  const save = () => {   // keep only cards still in the history
    const out = {};
    kept.forEach((h) => ['en', 'ar'].forEach((l) => { const c = cache[l + ':' + h]; if (c && Date.now() - c.t < 7 * DAY) out[l + ':' + h] = c; }));
    write(CACHE, out);
  };
  const ul = box.querySelector('ul.product-grid');
  let shown = '';
  const render = (cards) => {
    const html = cards.filter((c) => c && c.includes('card-wrapper')).join('');
    if (!html || html === shown) return;
    shown = html;
    ul.innerHTML = html;
    // phone: swipe only from 3 cards (a one-card slider looked cropped); desktop: slider only above 5, fewer are centred
    const n = ul.children.length;
    if (n < 3) ul.classList.remove('slider--tablet', 'grid--peek');
    if (n <= 5) ul.classList.remove('slider--desktop');
    if (n < 3 || n <= 5 && innerWidth >= 990) ul.classList.remove('slider');
    ul.querySelectorAll('li').forEach((li, i) => { li.id = 'Slide-' + ul.dataset.id + '-' + (i + 1); });
    box.hidden = false;
    const s = box.querySelector('slider-component');
    if (s && s.initPages) s.initPages();
  };
  if (show.length) {
    render(show.map((h) => (cache[lang + ':' + h] || {}).h));   // instant, from this phone's saved cards
    Promise.all(show.map(card)).then((cards) => { render(cards); save(); });   // fresh prices / stock
  }
  // product page: save this product's card now, so the next "Recently viewed" (cart, other products) shows it at once
  if (here) (window.requestIdleCallback || setTimeout)(() => card(here).then(save), 1500);
};
document.querySelectorAll('.bjo-rv').forEach(init);
// the cart page swaps its own HTML (item removed → empty again): set up the new row too (Hamza 2026-10-30)
if (document.querySelector('cart-items')) {
  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => document.querySelectorAll('.bjo-rv:not([data-ready])').forEach(init), 50); })
    .observe(document.querySelector('cart-items'), { childList: true, subtree: true });
}
})();
